import React from "react";
import { NavLink } from 'react-router-dom';
import Navigation from '../components/Navigation';


const Roman = () => {
    return(
        <div>
            <Navigation/>
            <h1>Voici les Romans</h1>
           
        </div>
    )
}

export default Roman